export const colorPrimary = "#0097A7";
export const colorPrimaryDark = "#075255";
export const colorLightGreen = "#129296";
export const colorPrimaryDarkAlpha = "#00616682";
export const colorGreenPale = "#E9F0F0";
export const colorLightGrey = "#F5F5F5";
export const colorDark = "#000000";
export const colorLight = "#FFFFFF";
export const colorGrey = "#808080";
export const colorYellowStrong = "#FEBD2B";
export const colorYellowMedium = "#FFD67B";
export const colorYellowLight = "#FFF5DF";
export const colorRed = "#ff0000";
export const colorPurpleDark ="#A72010";
export const colorDarkBlue = "#0F293C"
export const colorPrimaryPale = "#EEF9F8"
export const colorGold = "#D2A237"
export const colorGreen = "#62B146"

// pempem.io design system
export const colorNavBg = "#162133CC"
export const colorNavBgSolid = "#162133"
export const colorBorder = "#2E3D56"
export const colorMuted = "#7C8B9A"
export const colorForeground = "#D9DEE5"
export const colorAccent = "#E67316"
export const colorAccentAlpha = "rgba(230,115,22,0.1)"
export const colorMutedBg = "#2B3B54"